import { Container, Icon, Tooltip } from "@fluidattacks/design";
import _ from "lodash";

import { dependencyTypeConfig } from "features/vulnerabilities/formatters/dependency-type";
import { DependencyType } from "gql/graphql";

const DependencyTypeIcon = ({
  dependencyType,
}: {
  dependencyType: DependencyType | null | undefined;
}): React.JSX.Element => {
  const config =
    _.isNil(dependencyType) || !(dependencyType in dependencyTypeConfig)
      ? dependencyTypeConfig[DependencyType.Undeterminable]
      : dependencyTypeConfig[dependencyType];

  return (
    <Container
      left={"-10px"}
      position={"relative"}
      textAlign={"center"}
      width={"100%"}
    >
      <Tooltip
        id={config.id}
        place={"top"}
        tip={_.capitalize(config.id)}
        width={"100%"}
      >
        <Icon
          icon={config.icon}
          iconColor={config.color}
          iconSize={"xl"}
          iconType={"fa-solid"}
        />
      </Tooltip>
    </Container>
  );
};

const formatDependencyTypeIcon = (
  dependencyType: DependencyType | null | undefined,
): React.JSX.Element => {
  return <DependencyTypeIcon dependencyType={dependencyType} />;
};

export { formatDependencyTypeIcon };
